<template>
  <div>
    <ExportBill :Fn="exportOverviewBill" class="mb-16px" />
    <el-table :data="dataList" style="width: 100%">
      <el-table-column prop="serviceCodeName" label="产品名称">
      </el-table-column>

      <el-table-column prop="percent" label="消费占比"> </el-table-column>

      <el-table-column prop="billFee" label="原价"> </el-table-column>

      <el-table-column prop="discountFee" label="优惠金额"> </el-table-column>

      <el-table-column prop="actualFee" label="应付费用"> </el-table-column>

      <el-table-column prop="cashPayFee" label="现金支付"> </el-table-column>

      <el-table-column prop="payCouponFee" label="付费代金券支付">
      </el-table-column>

      <el-table-column prop="freeCouponFee" label="免费代金券支付">
      </el-table-column>

      <el-table-column prop="arrearFee" label="欠费金额"></el-table-column>

      <el-table-column prop="performanceFee" label="计入业绩金额">
      </el-table-column>

      <el-table-column fixed="right" label="操作" width="100">
        <template v-slot:default="{ row }">
          <el-button
            @click="
              $router.push({
                name: 'billDetails',
                query: {
                  pin: overviewForm.pin,
                  billDate: overviewForm.billDate,
                  serviceCode: row.serviceCode,
                  appCode: row.appCode
                }
              })
            "
            type="text"
            size="small"
            >查看明细</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import ExportBill from '@/views/channel/components/ExportBill.vue'
import { exportBillSummaryDetail } from '@/api/channel-api'
import { Message } from '@jdcloud/jelement-next'

export default {
  // 组件名称
  name: 'OverviewList',
  props: {
    dataList: {
      type: Array,
      default: () => []
    },
    overviewForm: {
      type: Object,
      // eslint-disable-next-line prettier/prettier
      default: () => { }
    }
  },
  components: { ExportBill },
  methods: {
    async exportOverviewBill() {
      try {
        const { result } = await exportBillSummaryDetail({
          params: {
            ...this.overviewForm
          }
        })
        Message.success(result.message)
        const url = derivativeConfig.exportUrl
        window.open(url)
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
